import { PrismicRichText } from "@prismicio/react"
import htmlSerializer from "../../../shared/utils/prismicHTMLSerializer"
import Button from "../../../shared/components/prismic/Button"
import BasicImage from "../../../shared/components/prismic/BasicImage"
import cx from "classnames"
import styles from "../styles/StudioHero.module.scss"

const StudioHero = ({ slice }) => {
  const { primary } = slice

  return (
    <header className={cx(styles.studioHero, "fullWidth")}>
      <div className={styles.contain}>
        <BasicImage className={styles.imageCol} image={primary.hero_image} />
        <div className={styles.title}>
          <h1 className="hOne">{primary.hero_header}</h1>
        </div>
        <div className={styles.descriptionCol}>
          <PrismicRichText field={primary.hero_text} components={htmlSerializer} />
          {primary.button_text && primary.button_url && <Button slice={slice} />}
        </div>
      </div>
    </header>
  )
}

export default StudioHero
